import React from 'react'
import ReactDOM from 'react-dom/client'
import './variable.scss'
import './index.css'
import 'material-icons/iconfont/material-icons.css'
import App from './App'
import * as Sentry from '@sentry/react'

// check if we are in production with vite

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://856e17e80dc5e6edecffa55f99f0b489@o1047151.ingest.us.sentry.io/4507429811126272',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.˚
  })
} 

if (import.meta.env.VITE_SITE_VERSION) {
  console.log(
    `%cBottaroInterventi - %c${import.meta.env.VITE_SITE_VERSION}`,
    'color:#fff055; background: #7575ff;',
    'color:white;font-weight: bold;background: #7575ff;'
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
